import { render, staticRenderFns } from "./Q4Edit.vue?vue&type=template&id=9adab812&scoped=true&"
import script from "./Q4Edit.vue?vue&type=script&lang=js&"
export * from "./Q4Edit.vue?vue&type=script&lang=js&"
import style0 from "./Q4Edit.vue?vue&type=style&index=0&id=9adab812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9adab812",
  null
  
)

export default component.exports